import axios from 'axios';
import qs from 'qs';

export const api = axios.create({
  baseURL: process.env.API_BASE_URL || '',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    serialize: (params) => {
      return qs.stringify(params, {
        allowDots: true,
        arrayFormat: 'brackets',
        skipNulls: true,
      });
    },
  },
  responseType: 'json',
  timeout: 60000,
  withCredentials: false,
});

export const setAuthToken = (token: string) => {
  api.interceptors.request.use((config) => {
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  });
};
